import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable()
export class GenericValidator {
    validateFormControl(form) {
        Object.keys(form.controls).forEach(field => {
            const control = form.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({
                    onlySelf: true
                });
            }
        })
    }
}
